var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _vm._v(
        "\n    深圳埃努码信息技术有限公司及关联公司（以下统称“我们”或“埃努码公司”）深知个人信息（本政策所述“个人信息”或“个人敏感信息”所包含的内容出自于《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《儿童个人信息网络保护规定》等相关法律法规，以及参考《信息安全技术个人信息安全规范》（GB/T35273）等国家标准）对您而言的重要性，也感谢您对我们的信任，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。基于此，我们制定本《个人信息保护政策》。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本政策主要向您阐述我们在您使用我们提供的移动应用程序中收集、存储、委托处理、共享、公开披露您和/或您孩子个人信息的目的、方式、范围和信息安全保护措施，以及我们为您提供的访问、更正、删除等控制个人信息的方法，包括您所享有的权利等，并申明了我们对保护个人隐私的承诺。以下是我们的特别提示，请您重点关注：\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.对我们认为可能会对您和/或孩子的权益产生重大影响的重点内容，我们采用“加粗”的书写方式进行提示。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    2. 对个人信息，我们采用“加粗斜体”的书写方式进行特别提醒，希望您在阅读时特别关注。在您向我们提供您和/或您孩子的任何个人信息前，您已慎重考虑并在此确认该等提供是适当的，您在此同意您和/或您孩子的个人信息可按照本政策所述的目的和方式进行处理。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3. 我们尤其重视对儿童个人信息的保护。我们将遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，收集、使用、存储、委托处理、共享、公开披露您和/或您孩子的个人信息。根据中国境内法律法规，您确认并承诺您是使用埃努码公司产品与/或服务的未成年人的监护人，或者已满18周岁但仍有兴趣使用埃努码公司产品与/或服务的成年用户。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    4. 对个人信息的权利实现方式，我们提供包括访问、更正或修改、删除、注销账号、及时得到响应等，以确保您实现对您和/或您孩子个人信息的控制权。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    5. 我们将恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、公开透明原则、确保安全原则、主体参与原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "我们会严格依据本政策以及您的同意处理您和/或您孩子的个人信息。如您不同意本政策，您应当停止使用埃努码公司产品与/或服务；您继续使用埃努码公司产品与/或服务的行为视为您充分理解并同意本政策的全部内容。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    6．我们未来可能根据信息处理情境的变化更新或修改本政策。请您在使用埃努码公司提供的任何服务前知晓本政策和任何补充政策。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本政策适用于埃努码公司提供服务的所有产品及服务，包括且不仅限于：\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    应用程序："),
      _c("b", [
        _vm._v(
          "都都数学，都都英语，都都思维，都都GO，都都kids，都都one，都都家长服务，都都服务；"
        ),
      ]),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    网站：enuma.cn,todomath.cn,todokids.cn,todoone.cn;\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如您对本政策内容有任何疑问、意见或建议，请通过以下方式与我们联系：\n    联系电话：18810316494（周一到周五9:00-21:00）\n    联系微信：TodoServer01\n    联系QQ：2179916770\n    联系邮箱：2179916770@qq.com\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    本版发布日期：2024年10月29日"),
      _c("br"),
      _vm._v("\n    生效日期：2024年10月29日\n    "),
      _c("br"),
      _c("br"),
      _vm._v("\n    目录\n    "),
      _c("br"),
      _c("br"),
      _vm._v("\n    本隐私政策将帮助您了解以下内容："),
      _c("br"),
      _vm._v("\n    一、个人信息定义及范围"),
      _c("br"),
      _vm._v("\n    二、我们如何使用和收集您的个人信息"),
      _c("br"),
      _vm._v("\n    三、我们如何使用Cookie和同类技术"),
      _c("br"),
      _vm._v("\n    四、我们如何共享、转让、公开披露您的个人信息"),
      _c("br"),
      _vm._v("\n    五、我们如何保护您的个人信息"),
      _c("br"),
      _vm._v("\n    六、您的权利"),
      _c("br"),
      _vm._v("\n    七、我们如何保护和处理儿童的个人信息"),
      _c("br"),
      _vm._v("\n    八、我们如何存储您和/或您孩子的个人信息"),
      _c("br"),
      _vm._v("\n    九、本隐私政策如何更新"),
      _c("br"),
      _vm._v("\n    十、争议解决"),
      _c("br"),
      _vm._v("\n    十一、如何联系我们"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("一、个人信息定义及范围")]),
      _vm._v(
        "\n    （一）个人信息：指以电子或者其他方式记录的能够单独或与其他信息结合，识别特定自然人身份或者反映特定自然人活动情况的信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "（二）个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、未满14周岁儿童的个人信息等。"
        ),
      ]),
      _c("br"),
      _vm._v(
        "\n    （三）设备：设备是指可用于访问我们产品或使用都都服务的装置，例如笔记本电脑、平板电脑、智能手机等。"
      ),
      _c("br"),
      _vm._v("\n    本隐私政策中涉及的个人信息及个人敏感信息主要包括：\n    "),
      _c("br"),
      _vm._v("1 .基本信息： 个人电话号码、电子邮箱；"),
      _c("br"),
      _vm._v("\n    2.网络身份标识信息：系统账号(含第三方)、IP地址、昵称；"),
      _c("br"),
      _vm._v(
        "\n    3.埃努码使用数据：软件使用记录、通过麦克风输入的内容、 应用崩溃信息；"
      ),
      _c("br"),
      _vm._v(
        "\n    4.常用设备信息 ：硬件型号、操作系统类型、位置信息（国家/地区）；"
      ),
      _c("br"),
      _vm._v(
        "\n    5.技术标识符：设备ID，IMEI、AndroidID、GAID（广告商的Google标识符）和IDFA（广告商的iOS标识符）"
      ),
      _c("br"),
      _vm._v("\n    6.使用第三方服务产生的资金流水记录。\n\n    "),
      _c("h2", [_vm._v("二、我们如何使用和收集您的个人信息")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h3", [_vm._v("1. 我们的基础业务功能包括：")]),
      _vm._v(" "),
      _c("b", [_vm._v("注册/登录")]),
      _vm._v(
        "：您在使用我们的产品时，需要先完成注册和登录。注册和登录都需要您提供"
      ),
      _c("b", [_vm._v("电子邮箱")]),
      _vm._v("。同时我们也支持更方便快捷的共享登录方式，即使用"),
      _c("b", [_vm._v("Apple ID、Google ID、手机号")]),
      _vm._v("等账号登录。"),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("支付")]),
      _vm._v(
        "：您在我们的产品及网站上支付时，您可以选择合作的第三方支付机构（如微信支付、支付宝、苹果商店等支付通道）所提供的支付服务。支付功能本身并不收集您的个人信息，但我们需要将您的"
      ),
      _c("b", [_vm._v("订单信息及对账信息")]),
      _vm._v("与这些支付机构共享以确认您的支付指令并完成支付。"),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("学习能力测试")]),
      _vm._v(
        "：您在使用产品之前，可以选择是否参加学习能力测试，作答完成后将由系统判定结果，并设定首次使用产品时合适的水平等级。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("设置孩子的学习存档")]),
      _vm._v(
        "：您在给孩子创建学习存档过程中，可选择登记孩子昵称或代号，填写非真实的孩子出生年月信息，选择使用的难度等级。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们会出于本政策所述的以下目的，收集和使用您的个人信息：\n    "
      ),
      _c("h3", [_vm._v("2. 向您提供产品与/或服务过程中您主动提供的个人信息")]),
      _vm._v("\n    2.1 帮助您成为我们产品的用户"),
      _c("br"),
      _vm._v(
        "\n    为使用埃努码公司的服务之前，您需要首先成为我们的注册用户，以便我们为您提供会员服务，您需要提供"
      ),
      _c("b", [_c("i", [_vm._v("注册、登录帐号使用的电子邮箱或手机号")])]),
      _vm._v(
        "，创建应用程序的账号和密码。在您主动注销账号之后，我们将根据法律的要求删除您的个人信息，或使其匿名化处理。您也可以直接在应用程序内直接修改，或通过本政策第10条提供的联系方式，要求我们协助您更正或删除信息。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    2.2 创建使用档案"),
      _c("br"),
      _vm._v(
        "\n    为了让您和孩子在使用我们产品时能有良好的体验，建议您在我们产品中根据弹窗提示填写使用者的"
      ),
      _c("b", [_c("i", [_vm._v("昵称、出生日期")])]),
      _vm._v(
        "，以便帮助您和/或您孩子创建使用档案。如您未填写此类信息，将无法完成档案创建，因此影响您正常使用我们产品中的其他功能。"
      ),
      _c("b", [
        _vm._v(
          "我们特别提醒您：为了保护您、孩子的隐私，建议您不要使用真实姓名作为昵称，也不要轻易将您、孩子的真实身份信息公开发布或与他人分享"
        ),
      ]),
      _vm._v("。\n    "),
      _c("br"),
      _vm._v("\n    2.3 语音测评"),
      _c("br"),
      _vm._v(
        "\n    在都都的部分产品中，我们设置了自动化技术的语音评测功能。当您和/或您孩子使用该功能时，可能需要上传语音来判断当前"
      ),
      _c("b", [_vm._v("语言")]),
      _vm._v(
        "表达等能力。如您不提供此类信息，我们可能无法为您提供必需应用语音评测的功能。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    2.4 开展营销活动"),
      _c("br"),
      _vm._v(
        "\n    为了更好的向您和/或您孩子提供服务，我们可能会通过短信、邮件的方式，向您发送商业性服务/促销信息、产品与/或服务的最新消息、有关管理等与我们产品与/或服务有关的通知。"
      ),
      _c("br"),
      _vm._v(
        "\n    我们仅通过短信、第三方公众平台或邮件提供营销服务，APP内无定向广告或推送。如果您不想接收这些营销服务，可以发邮件至2179916770@qq.com或回复短信“退订”申请取消。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    2.5 客服与售后"),
      _c("br"),
      _vm._v(
        "\n    当您联系我们进行咨询产品或服务相关问题时，包括跨设备同步数据，恢复丢失的用户数据及会员信息查询，为了您的账号与系统安全，您需要向我们提供您的"
      ),
      _c("b", [_c("i", [_vm._v("联系方式和账户相关信息、订单截图（如有）")])]),
      _vm._v("，以便我们对您的用户身份进行核验。您还需要向我们提供相应的"),
      _c("b", [_c("i", [_vm._v("证明材料（图片、视频或者文本信息）")])]),
      _vm._v(
        "，以便快速解决您提出的问题。当您与我们联系时，我们可能会保存您的"
      ),
      _c("b", [_c("i", [_vm._v("通信或通话记录和内容）")])]),
      _vm._v("或您留下的"),
      _c("b", [_c("i", [_vm._v("联系方式")])]),
      _vm._v(
        "，以便帮助您解决问题，或记录相关问题的处理方案及结果。如您不提用上诉信息，我们可能无法向您及时反馈咨询的结果，或为您解决问题，但不影响您和/或您孩子正常使用服务中的其他内容。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h3", [
        _vm._v("3. 向您提供产品与/或服务过程中我们主动收集的个人信息"),
      ]),
      _vm._v("\n    3.1 用户体验改进"),
      _c("br"),
      _vm._v(
        "\n    当您使用我们产品时，我们将基于您对产品使用数据，结合个人常用设备信息进行统计，来诊断系统问题，优化产品体验。\n    "
      ),
      _c("br"),
      _vm._v("\n    3.1.1  设备信息"),
      _c("br"),
      _vm._v(
        "\n    我们会使用工具统计您在使用我们产品过程中，包含产品在后台状态/静默状态下产生的数据信息，包括"
      ),
      _c("b", [
        _c("i", [
          _vm._v(
            "设备型号、设备ID、，设备所在位置的相关信息（IP地址），IDFA（仅限IOS），Android ID（仅限安卓），国家设置，使用语言，"
          ),
        ]),
      ]),
      _vm._v("我们将对这些信息进行关联，以便我们能够为您提供一致的服务。"),
      _c("br"),
      _vm._v("\n    请您特别注意：某些第三方SDK还会收集您设备的"),
      _c("b", [_c("i", [_vm._v("Mac地址")])]),
      _vm._v(
        "，我们会要求我们的应用中接入的所有第三方SDK只能在您同意本政策后才能初始化和收集您的个人信息，详情请见第4条"
      ),
      _c("b", [_vm._v("第三方软件开发工具包（SDK）及说明")]),
      _vm._v("。\n    "),
      _c("br"),
      _vm._v("\n    3.1.2  日志信息"),
      _c("br"),
      _vm._v("\n    当您使用我们产品与/或服务时，我们会收集您的"),
      _c("b", [
        _c("i", [
          _vm._v(
            "产品崩溃日志，使用时间和频率，产品内玩过的游戏日志及结果等信息"
          ),
        ]),
      ]),
      _vm._v(
        "。收集这类信息是为了向您提供服务，以及改善我们产品的相关功能，为您提供更好的服务体验。"
      ),
      _c("br"),
      _vm._v(
        "\n    随着我们产品的后续版本升级，我们统计的范围会有所改变，您下载/安装/使用我们后续版本产品的行为将被视为您对届时相关改变的同意。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    3.1.3 为您提供安全保护保障"),
      _c("br"),
      _vm._v("\n    您的"),
      _c("b", [_c("i", [_vm._v("网络身份标识信息")])]),
      _vm._v("帮助您维护软件正常使用及使用安全。\n    "),
      _c("br"),
      _vm._v(
        "\n    我们的应用程序是针对儿童学习使用的，但在程序内有家长或老师设置或指导的区域，需通过“家长系统”进入。必须年满18周岁才能进入“家长系统”。作为父母或其他监护人，您可以选择同意或通过“家长系统”进入访问设置来拒绝自动收集数据。如果您不同意我们收集这些数据，我们将无法为您的使用提供某些服务或客户支持。只有您选择同意后，我们才会为您开启相应权限并接受您的个人信息。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    我们会根据您在软件安装及使用中授予的具体权限，接收并记录您的个人常用设备信息："
      ),
      _c("b", [_c("i", [_vm._v("操作系统版本、设备型号、IP地址")])]),
      _vm._v("。\n    "),
      _c("br"),
      _vm._v("\n    3.4 风险控制与安全保障"),
      _c("br"),
      _vm._v(
        "\n    为了保护您使用我们产品与/或服务时的安全、可靠，防止恶意程序和反作弊、网络入侵等风险，我们可能会收集您的产品"
      ),
      _c("b", [_c("i", [_vm._v("账号信息、设备信息、日志信息、订单信息")])]),
      _vm._v(
        "，以进行用户身份验证、检测安全风险，并依法采取必要的记录、分析、处置措施。\n    "
      ),
      _c("br"),
      _vm._v(" "),
      _c(
        "table",
        { attrs: { border: "1", cellspacing: "0", cellpadding: "6" } },
        [
          _c("tr", [
            _c("td", { attrs: { colspan: "4" } }, [
              _vm._v("收集个人信息明示信息清单"),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("业务场景")]),
            _c("td", { attrs: { width: "400" } }, [_vm._v("收集目的")]),
            _vm._v(" "),
            _c("td", [_vm._v("收集方式")]),
            _vm._v(" "),
            _c("td", [_vm._v("个人信息字段")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { rowspan: "2" } }, [_vm._v("注册、登录")]),
            _vm._v(" "),
            _c("td", { attrs: { rowspan: "2" } }, [
              _vm._v("用于注册创建账号，完善网络身份标识。"),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("用户输入")]),
            _vm._v(" "),
            _c("td", [_vm._v("邮箱地址、手机号、Apple ID、Google ID")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("APP收集")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "设备ID、IP、IDFA（仅限IOS），Android ID（仅限安卓），国家设置，使用语言"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { rowspan: "2" } }, [_vm._v("创建使用者")]),
            _vm._v(" "),
            _c("td", { attrs: { rowspan: "2" } }, [
              _vm._v(
                "用于用户在账号内，创建不同的使用者存档，以方便不同使用者使用。"
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("用户输入")]),
            _vm._v(" "),
            _c("td", [_vm._v("昵称/代号、（非真实）出生年月、使用等级")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("APP收集")]),
            _vm._v(" "),
            _c("td", [_vm._v("操作设备型号、操作系统版本、产品的使用数据")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { rowspan: "2" } }, [_vm._v("使用软件过程中")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "通过收集使用者的语音内容、处理并完成产品内的跟读、发音测试。"
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("用户输入")]),
            _vm._v(" "),
            _c("td", [_vm._v("语音内容")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("收集使用者的使用数据，改善产品和使用体验。")]),
            _vm._v(" "),
            _c("td", [_vm._v("APP收集")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "产品崩溃日志，使用时间和频率，产品内玩过的游戏日志及结果等信息"
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(
        "\n    除以下情况外，我们不会与任何第三方共享，披露或出售我们收集的信息：\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    a. 我们使用第三方服务提供商来帮助运营我们的服务，例如云服务，付款处理。此类第三方提供商仅将信息用于我们与他们签约的服务，并且必须遵守与本政策相同级别的数据保护\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h3", [_vm._v("4. 第三方软件开发工具包（SDK）及说明")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "a.出于技术需要，产品需嵌入第三方软件开发工具包（SDK）来完成必要的服务内容，包括付款处理、功能使用实现、云服务等。我们产品所嵌入的第三方SDK及第三方SDK所需收集或与之共享的信息如下:"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "table",
        { attrs: { border: "1", cellspacing: "0", cellpadding: "5" } },
        [
          _c("tr", [
            _c("td", { attrs: { colspan: "5" } }, [
              _vm._v("第三方共享信息清单"),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("第三方公司")]),
            _c("td", [_vm._v("使用目的")]),
            _vm._v(" "),
            _c("td", [_vm._v("第三方收集个人信息的方式")]),
            _vm._v(" "),
            _c("td", [_vm._v("涉及个人信息")]),
            _vm._v(" "),
            _c("td", [_vm._v("第三方官网链接")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("微信支付SDK")]),
            _vm._v(" "),
            _c("td", [_vm._v("用户通过支付完成会员购买")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "动收集，且仅在启动APP、初始化SDK时进行收集；每一订单支付时获取订单下的交易信息，以确认并完成您的支付指令"
              ),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("b", [
                _c("i", [
                  _vm._v(
                    "设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("https://pay.weixin.qq.com/")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("支付宝SDK")]),
            _vm._v(" "),
            _c("td", [_vm._v("用户通过支付完成会员购买")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "自动收集，且仅在启动APP、初始化SDK时进行收集；每一订单支付时获取订单下的交易信息，以确认并完成您的支付指令"
              ),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("b", [
                _c("i", [
                  _vm._v(
                    "设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息、传感器、设备序列号、ip地址、运营商信息"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("https://www.alipay.com")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Cocos2D-X")]),
            _vm._v(" "),
            _c("td", [_vm._v("用于判断在安全状态下启动软件")]),
            _vm._v(" "),
            _c("td", [_vm._v("自动收集，且仅在启动APP、初始化时进行收集")]),
            _vm._v(" "),
            _c("td", [_c("b", [_c("i", [_vm._v("设备传感器")])])]),
            _vm._v(" "),
            _c("td", [_vm._v("https://cocos2d-x.org/download")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("h3", [_vm._v("5. 征得授权同意的例外")]),
      _vm._v(
        "\n    根据相关法律法规规定及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：\n    "
      ),
      _c("br"),
      _vm._v("\n    （1）与国家安全、国防安全直接相关的；\n    "),
      _c("br"),
      _vm._v("\n    （2）与公共安全、公共卫生、重大公共利益直接相关；\n    "),
      _c("br"),
      _vm._v("\n    （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；\n    "),
      _c("br"),
      _vm._v(
        "\n    （4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；\n    "
      ),
      _c("br"),
      _vm._v("\n    （5）所收集的个人信息是您自行向社会公众公开的；\n    "),
      _c("br"),
      _vm._v(
        "\n    （6）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道；\n    "
      ),
      _c("br"),
      _vm._v("\n    （7）根据您的要求签订和履行合同所必须的；\n    "),
      _c("br"),
      _vm._v(
        "\n    （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现或处置产品或服务的故障；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    （9）为新闻单位或学术研究机构基于新闻报道、公共利益开展统计或学术研究所必要等，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理，且数据接收方无法复原并重新识别个人信息的；\n    "
      ),
      _c("br"),
      _vm._v("\n    （10）"),
      _c("b", [_vm._v("与个人信息控制者履行")]),
      _vm._v("法律法规规定的"),
      _c("b", [_vm._v("义务相关的。")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("三、我们如何使用Cookie和同类技术")]),
      _vm._v(
        "\n    当您访问我们的网站时，我们和我们的第三方服务提供商会自动通过技术收集您的信息，例如通过Google Analytics（分析）发送您使用浏览器的cookie，这些信息会唯一标识您的浏览器。这些技术可以随着时间的推移以及跨不同网站，从您的计算机或移动设备收集信息。这将跟踪您的使用方式，以便我们更好地了解用户的偏好，了解家长和教育者如何了解我们，并监控我们营销工作的有效性。收集的信息可能包括IP地址和大概的地理位置（国家/地区），以便我们可以更好地将我们的服务与您的兴趣和需求相匹配，或者确定适用的隐私法规。我们不会将自动收集的信息与任何个人身份信息合并。大多数浏览器允许您禁用cookie，或者您可以将浏览器设置为“在将cookie发送到计算机时向您发出警报”。您也可以在浏览器选择退出Google Analytics（分析）。我们不会出售或出租与其他方收集的信息。我们可能会不时在电子邮件中使用Web信标，以了解与父母和教育者进行哪种通信。\n\n    "
      ),
      _c("h2", [_vm._v("四、我们如何共享、转让、公开披露您的个人信息")]),
      _vm._v(" "),
      _c("h3", [_vm._v("（一）共享")]),
      _vm._v(
        "\n    我们不会与除我们及我们的关联方以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：\n    "
      ),
      _c("br"),
      _vm._v("\n    在以下情形中，您可以向我们提出删除个人信息的请求：\n    "),
      _c("br"),
      _vm._v("\n    1. 事先获得您明确的同意或授权；\n    "),
      _c("br"),
      _vm._v(
        "\n    2. 根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下对外提供；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    3. 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；\n    "
      ),
      _c("br"),
      _vm._v("\n    4. 应您要求为您处理您与他人的纠纷或争议；\n    "),
      _c("br"),
      _vm._v(
        "\n    5. 与授权合作伙伴共享：在法律法规允许的范围内，为维护我们的合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害，"
      ),
      _c("b", [
        _vm._v(
          "我们仅为实现本隐私政策中声明的目的与授权合同伙伴共同提供某些服务。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。"
        ),
      ]),
      _vm._v(
        "我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的数据和信息。"
      ),
      _c("b", [
        _vm._v(
          "我们将审慎评估合作方使用共享信息的目的，对合作方的安全保障能力进行综合评估，我们会对合作方获取信息的软件工具开发包、"
        ),
      ]),
      _vm._v("应用程序接口（API）进行严格的安全监测，以保护数据安全 ，"),
      _c("b", [_vm._v("我们的合作伙伴无权将共享的个人信息用于任何其他用途。")]),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n    我们的授权合作伙伴包括以下类型：\n    "),
      _c("br"),
      _vm._v(
        "\n    (1)商品或技术服务的服务商。我们可能会聘请各种第三方服务提供商来为我们执行功能和服务。这些第三方服务包括付款处理，云服务，在线广告和数据分析。我们会与被授权使用任何个人信息的服务提供商共享您的数据，这些服务提供商仅在向我们提供需要的服务时使用任何个人信息，且服务商同意对信息保密，并提供与本隐私政策相同级别的数据保护。当您购买订阅时，我们收集有关购买的信息，包括货币和花费的金额，但是我们不收集付款或账单信息。当您根据服务条款订阅我们的服务时，支付服务提供商将处理和处理支付数据。我们不会直接获取或收集您的付款信息；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    (2)第三方商家。我们必须将您为实现操作目的之必要信息与第三方商家共享，并促使其可以完成后续服务；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    (3)对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。\n    "
      ),
      _c("h3", [_vm._v("（二）转让")]),
      _vm._v(
        "\n    我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：\n    "
      ),
      _c("br"),
      _vm._v("\n    1. 事先获得您明确的同意或授权；\n    "),
      _c("br"),
      _vm._v(
        "\n    2. 根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    3. 符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    4. 在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会"
      ),
      _c("b", [_vm._v("向您告知接受方的名称或者姓名和联系方式，")]),
      _vm._v(
        "并要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，如接收方变更原先的处理目的、处理方式,我们将要求该公司、组织重新向您征求授权同意。\n    "
      ),
      _c("h3", [_vm._v("（三）公开披露")]),
      _vm._v(
        "\n    我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    1. 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    2. 根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。\n    "
      ),
      _c("h3", [
        _vm._v("（四）共享、转让、公开披露个人信息时事先征得授权同意的例外"),
      ]),
      _vm._v(
        "\n    以下情形中，我们共享、转让、公开披露您的信息无需事先征得您的授权同意：\n    "
      ),
      _c("br"),
      _vm._v("\n    1. 与国家安全、国防安全直接相关的；\n    "),
      _c("br"),
      _vm._v("\n    2. 与公共安全、公共卫生、重大公共利益直接相关的；\n    "),
      _c("br"),
      _vm._v("\n    3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；\n    "),
      _c("br"),
      _vm._v(
        "\n    4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；\n    "
      ),
      _c("br"),
      _vm._v("\n    5. 您自行向社会公众公开的个人信息；\n    "),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("6. 与个人信息控制者履行法律法规规定的义务相关的；")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n    7. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。\n    "
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "对外共享、转让、公开披露您的个人信息，我们对此负责，并承担相应的法律责任。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("五、我们如何保护您的个人信息")]),
      _vm._v(
        "\n    1. 我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。\n    "
      ),
      _c("br"),
      _vm._v("\n    2. SSL（Secure Socket Layer）协议加密保护。\n    "),
      _c("br"),
      _vm._v(
        "\n    当您从设备或浏览器向我们的服务器发送或收取信息时，我们确保使用安全套接层（SSL）和其他算法对其进行加密。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    3. 我们会采取一切合理可行的措施，确保未收集无关的个人信息。"
      ),
      _c("b", [
        _vm._v(
          "我们只会在达成本政策所述目的所需的三年内保留您的个人信息，除非需要延长保留期或受到法律的允许。超出期限后，我们将删除或去标识化处理您的个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n    4. 您的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。我们依据重要性和敏感性对您的数据进行分类，并且保证您的个人信息具有最高的安全等级。我们保证通过访问这些信息来帮助向您提供产品和服务的员工和第三方服务供应商具有严格的合同保密义务，如果未能履行这些义务，其将会受到纪律处分或被终止合作。同样，我们对以云为基础的数据存储设有专门的访问控制措施。总而言之，我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。\n    "
      ),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。"
        ),
      ]),
      _vm._v(
        "因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。我们将对于个人数据的泄露，及时通知相关的监管机构，并在一些特别的环境下，通知数据主体相关的数据泄露事件，以满足适用的相关法律，包括您所在地的数据保护法规。\n    我们不对有可能进入第三方网站的隐私政策的合法性负责，您应检查第三方网站的隐私政策并确定是否接受。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    5. 在不幸发生个人信息安全事件后，我们将按照法律法规的要求并最迟不迟于15个自然日内向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范或降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。\n\n    "
      ),
      _c("h2", [_vm._v("六、您的权利")]),
      _vm._v(
        "\n    按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：\n    "
      ),
      _c("h3", [_vm._v("1. 访问权")]),
      _vm._v(
        "\n    您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：\n    帐号信息；如果您希望访问或编辑您的帐号中的个人资料信息、更改您的密码或关闭您的帐号等，您可以通过访问【家长系统】-【用户存档】执行此类操作。\n    "
      ),
      _c("h3", [_vm._v("2. 更正权")]),
      _vm._v("\n    当您发现我们处理的关于您的个人信息有错误时，"),
      _c("b", [
        _vm._v("您可以直接在我们产品内通过访问"),
        _c("b", [_vm._v("【家长系统】-【用户存档】")]),
        _vm._v(
          "页面直接编辑或更正您的资料信息，包括且不限于修改账号密码、更换绑定的手机号、修改昵称、更换使用等级等。\n    "
        ),
        _c("br"),
        _vm._v(
          "\n    如您在行使上述权利过程中遇到困难，您可通过本政策第10条提供的联系方式联系我们，我们将在核实您的身份后及时响应您的请求，但法律法规另有规定的或本政策另有约定的除外。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h3", [_vm._v("3. 删除权")]),
      _vm._v("\n    在以下情形中，您可以向我们提出删除个人信息的要求：\n    "),
      _c("br"),
      _vm._v(
        "\n    (1) 如果我们处理个人信息的行为违反法律法规或与您的约定；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    (2) 如果我们收集、使用您的个人信息，却未征得您的同意；\n    "
      ),
      _c("br"),
      _vm._v("\n    (3) 您撤回同意的；\n    "),
      _c("br"),
      _vm._v("\n    (4) 如果您通过注销的方式终止使用我们的产品或服务；\n    "),
      _c("br"),
      _vm._v("\n    (5) 如果我们不再为您提供产品或服务；\n    "),
      _c("br"),
      _vm._v("\n    (6) 其他法律法规等规定的情形。\n    "),
      _c("br"),
      _vm._v(
        "\n    如您希望删除您和/或您孩子的个人信息，您可以通过本政策第10条提供的联系方式联系我们，我们将在核实您的身份后及时响应您的请求。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    您在此同意，若我们响应并完成您的删除请求，您和/或您孩子的个人信息将被删除。我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    请您知悉，当您被从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。\n    "
      ),
      _c("br"),
      _vm._v(" "),
      _c("h3", [_vm._v("4. 撤回同意权")]),
      _vm._v("\n    您可以通过"),
      _c("b", [_vm._v("微信、QQ、邮件的方式")]),
      _vm._v(
        "联系客服向我们提出撤回收集、使用个人信息的同意授权。撤回同意后，我们后续不会再处理您的个人信息。同时，我们会保障您拒绝接收基于您个人信息推送的商业广告的权利。在我们对外共享、转让、公开披露您的个人信息时，我们会向您提供撤回同意的通知。"
      ),
      _c("u", [
        _c("b", [
          _vm._v("撤回同意不影响撤回前基于同意的您的个人信息处理和存储。"),
        ]),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("5. 注销权")]),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "除非法律法规另有规定或本政策另有约定，您可以直接在都都产品内通过访问“家长”按钮，在“用户存档”的“我的账号”-“账号管理”下方的“注销服务”来注销账号。\n    "
        ),
        _c("br"),
        _vm._v(
          "\n    请您知悉，在注销账号后，除非根据法律法规或根据监管部门的要求保留或存储您和/或您孩子的个人信息，否则我们将即时删除您和/或您孩子的个人信息或作匿名化处理。请您知悉，我们可能不会将该等信息立即从备份系统中删除，但会在备份系统更新时进行删除。\n    "
        ),
        _c("br"),
        _vm._v(
          "\n    您注销账号的行为是不可逆的，一旦您的账号被注销，我们将不再收集您和/或您孩子的个人信息，也不再为您提供都都产品与/或服务。因此我们建议您谨慎选择注销账号。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h3", [_vm._v("6. 查询权")]),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "账号信息：您可以通过都都产品内，通过访问“家长”按钮，查看“用户存档”-“我的账号”来查询您的账号信息；\n    "
        ),
        _c("br"),
        _vm._v(
          "\n    使用信息：您可以通过都都产品内，通过访问“家长”按钮，查看“用户存档”-“学习报告”来查询您的使用信息；"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h3", [_vm._v("7. "), _c("b", [_vm._v("获取个人信息副本")])]),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "如果您需要孩子档案及学习记录的副本，您可以通过本政策第10条提供的联系方式联系我们，我们将在核实您的身份后及时响应您的请求。"
        ),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("8. 响应您的上述请求")]),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "如果您无法通过上述方式管理您的个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您可通过本政策第10条提供的联系方式联系我们。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n    为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。\n    "
      ),
      _c("br"),
      _vm._v("\n    我们将在十五天内做出答复。\n    "),
      _c("br"),
      _vm._v(
        "\n    对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。\n    "
      ),
      _c("br"),
      _vm._v("\n    在以下情形中，我们将无法响应您的请求：\n    "),
      _c("br"),
      _vm._v("\n    1. 与个人信息控制者履行法律法规规定的义务相关的；\n    "),
      _c("br"),
      _vm._v("\n    2. 与国家安全、国防安全直接相关的；\n    "),
      _c("br"),
      _vm._v("\n    3. 与公共安全、公共卫生、重大公共利益直接相关的；\n    "),
      _c("br"),
      _vm._v("\n    4. 与刑事侦查、起诉、审判和执行判决等直接相关的；\n    "),
      _c("br"),
      _vm._v(
        "\n    5. 个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    6. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    7. 响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；\n    "
      ),
      _c("br"),
      _vm._v("\n    8. 涉及商业秘密的。\n    "),
      _c("h2", [_vm._v("七、我们如何保护和处理儿童的个人信息")]),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "请您知悉，根据我国法律，您确认并承诺您是使用都都产品与/或服务的儿童的监护人，或者已满18周岁但仍有兴趣使用都都产品与/或服务的成年用户。如您不同意本政策，我们将不会收集您和/或您孩子的个人信息。\n    "
        ),
        _c("br"),
        _vm._v(
          "如果你是14周岁以下的未成年人，你需要和你的监护人一起仔细阅读本政策，并在征得你的监护人同意后，使用我们的产品、服务或向我们提供信息。\n    "
        ),
        _c("br"),
        _vm._v(
          "特别地，如果您是14周岁以下儿童的，在使用平台功能或服务前，您应请您的监护人仔细阅读我们专门制定的《"
        ),
        _c("a", { attrs: { href: "/cn/privacy/kids" } }, [
          _vm._v("儿童个人信息保护规则"),
        ]),
        _vm._v(
          "》，确保在取得监护人对《儿童个人信息保护规则》的同意后，您才可在监护人的指导下使用平台功能或服务。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v("1、我们如何保护未成年人的个人信息\n    "),
      _c("br"),
      _vm._v(
        "我们会尽到最大可能，如通过家长控制的方式，保护您孩子的个人信息：（i）都都产品与/或服务通过特定环节（如超越儿童一般认知能力的较复杂的数学计算等）设立了家长验证功能；（ii）您可以在家长控制区域中的设置页面，控制您和/或您孩子的使用时长等；\n    "
      ),
      _c("br"),
      _vm._v("\n    2、我们如何处理未成年人的个人信息\n    "),
      _c("br"),
      _vm._v(
        "对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    如果我们发现自己在获得可证实的父母不同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    3、请您知悉，我们将不会直接向儿童出售任何都都产品与/或服务，请您妥善保管您的支付信息，防止您孩子误用。如您需要购买都都产品与/或服务，我们将通过特定验证方式（如进行超越儿童一般认知能力的较复杂的数学计算等方式）防止您的孩子错误操作，只有通过验证后您才能够进入家长控制区域进行购买。\n    "
      ),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("八、我们如何存储您和/或您孩子的个人信息")]),
      _vm._v(
        "\n    我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，我们不会将您的个人信息转移至境外。\n    如需发生数据跨境传输，我们会向您告知您数据出境的目的、接收方，并征得您的同意，我们会确保数据接收方有充足的数据保护能力来保护您和/或您孩子的个人信息。\n    我们承诺，除非法律法规另有要求，您和/或您孩子个人信息的存储时间将处于实现您授权使用的目的所必需的最短时间。\n\n    "
      ),
      _c("h2", [_vm._v("九、本隐私政策如何更新")]),
      _vm._v("\n    我们的隐私政策可能变更。\n    "),
      _c("br"),
      _vm._v(
        "\n    本政策为《用户协议》的重要组成部分。我们保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少（即“重大变更”），我们会通过不同渠道向您发送变更通知，包括但不限于网站公示、私信通知等方式。\n    若您不同意修改后的隐私政策，您有权并应立即停止使用我们的服务。如果您继续使用我们的服务，则视为您接受我们对本政策相关条款所做的修改。\n    我们的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明我们在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    本政策所指的重大变更包括但不限于：\n    "),
      _c("br"),
      _vm._v(
        "\n    1. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    2. 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；\n    "
      ),
      _c("br"),
      _vm._v("\n    3. 个人信息共享、转让或公开披露的主要对象发生变化；\n    "),
      _c("br"),
      _vm._v(
        "\n    4. 您参与个人信息处理方面的权利及其行使方式发生重大变化；\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    5. 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；\n    "
      ),
      _c("br"),
      _vm._v("\n    6. 个人信息安全影响评估报告表明存在高风险时；\n    "),
      _c("br"),
      _vm._v("\n    7. 我们还会将本政策的旧版本存档，供您查阅。\n    "),
      _c("br"),
      _vm._v(
        "\n    在我们公司或产品停止运营时，我们会及时停止继续收集个人信息，可能以注意送达或网站公告的形式通知您停止运营的情况，并对您的个人信息进行删除或匿名化处理。\n\n    "
      ),
      _c("h2", [_vm._v("十、争议解决")]),
      _vm._v(
        "\n    本用户协议及您与深圳埃努码公司的关系适用于中华人民共和国大陆地区法律，但不包括其冲突法规范。您和深圳埃努码公司同意服从深圳埃努码公司所在地法院的司法管辖。\n\n    "
      ),
      _c("h2", [_vm._v("十一、如何联系我们")]),
      _vm._v(
        "\n    我们已经配备个人信息保护专门负责人员，如果您对本隐私政策有任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过以下方式与我们联系：\n    "
      ),
      _c("br"),
      _vm._v("\n    （1）拨打客服电话：（86+）18810316494\n    "),
      _c("br"),
      _vm._v(
        "\n    （2）联系官方客服QQ：2179916770（工作时间：每日9：00-21：30）\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    （3）联系官方微信TodoServer01或微信公众号都都APP，在线咨询人工客服\n    "
      ),
      _c("br"),
      _vm._v("\n    （4）发送邮件至215032956@qq.com。\n    "),
      _c("br"),
      _vm._v(
        "\n    我们将在15个工作日内处理并答复您的投诉与意见。如无法响应您的请求，我们会在法律规定的最大时限要求内，向您发送通知并解释原因。\n    "
      ),
      _c("br"),
      _vm._v(
        "如您对我们的回复不满意，或我们对您和/或您孩子个人信息的处理方式侵害了您和/或您孩子的合法权益，且在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。\n    "
      ),
      _c("br"),
      _vm._v(
        "如果您对我们的答复不满意，还可以向消费者权益保护部门投诉或者向有管辖权的法院提诉讼。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    深圳埃努码信息技术有限公司\n\n"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }